import MiniAppMaterialsPage from './pages/MiniAppMaterials'
import BannerManage from "./pages/BannerManage"
import InstBannerManagePage from "./pages/InstBannerManagePage"
import InstMiniappConfigPage from "./pages/InstMiniappConfigPage"
import MiniAppConfig from "./pages/MiniAppConfig"
import HQMiniappOverview from "./pages/HQMiniappOverview"
import { useState, useEffect, useRef } from 'react'
import MiniPreviewPage from './pages/MiniPreview'
import UnifiedLoginPage from './pages/UniLogin'
import BaseDashboardPage from './pages/BaseDashboard'
import ChannelLoginPage from './pages/ChannelLogin'
import LogoutPage from './pages/LogoutPage'
import PartnerUnifiedLogin from './pages/PartnerUnifiedLogin'
import MusicLibraryPage from './pages/MusicLibraryPage'

import OrganizationLoginPage from './pages/OrganizationLogin'
import HQDashboardPage from './pages/HQDashboard'
import HQContentPage from './pages/HQContent'
import DashboardPage from './pages/Dashboard'
import AssetsPage from './pages/Assets'
import AISmartEditPage from './pages/AISmartEdit'
import MediaLibraryPage from './pages/MediaLibrary'
import EffectsLibraryPage from './pages/EffectsLibrary'
import TTSPage from './pages/TTS'
import SubtitlePage from './pages/Subtitle'
import ProductionPage from './pages/Production'
import PublishPage from './pages/Publish'
import AnalyticsPage from './pages/Analytics'
import SmsMarketingPage from './pages/SmsMarketing'
import CoursewareUploadPage from './pages/CoursewareUpload'
import WechatManagementPage from './pages/WechatManagement'
import WechatMarketingPage from './pages/WechatMarketing'
import CouponsPage from './pages/Coupons'
import GroupBuyPage from './pages/GroupBuy'
import RecommendPage from './pages/Recommend'
import StudyActivitiesPage from './pages/StudyActivities'
import TrainingPage from './pages/Training'
import CRMPage from './pages/CRM'
import OrdersPage from './pages/Orders'
import ProductsPage from './pages/Products'
import FinancePage from './pages/Finance'
import MembersPage from './pages/Members'
import PointsPage from './pages/Points'
import PartnersPage from './pages/Partners'
import PartnerRegisterPage from './pages/PartnerRegister'
import PartnerApplyPage from './pages/PartnerApply'
import PartnerCenterPage from './pages/PartnerCenter'
import PartnerStorePage from './pages/PartnerStore'
import ContractsPage from './pages/Contracts'
import PartnerContractPage from './pages/PartnerContractPage'
import GrowthPortalPage from './pages/GrowthPortal'
import SalespersonOverviewPage from './pages/SalespersonOverview'
import PartnerCommissions from './pages/PartnerCommissions'
import StoreSettlements from './pages/StoreSettlements'
import StoreManagement from './pages/StoreManagement'
import BaseReferral from './pages/BaseReferral'
import FinancialManagement from './pages/FinancialManagement'
import InstitutionRegisterPage from './pages/InstitutionRegister'
import BaseRegisterPage from './pages/BaseRegister'
import RegionalAgentRegisterPage from './pages/RegionalAgentRegister'
import RegionalAgentsPage from './pages/RegionalAgents'
import AgentCenterPage from './pages/AgentCenter'
import SalesCommissionConfigPage from './pages/SalesCommissionConfig'
import SalesCommissionPage from './pages/SalesCommission'
import ProfitSharingPage from './pages/ProfitSharing'
import PartnerPerformancePage from './pages/PartnerPerformance'
import SalespersonDashboardPage from './pages/SalespersonDashboard'
import ChannelsPage from './pages/Channels'
import SettlementsPage from './pages/Settlements'
import BasesPage from './pages/Bases'
import StudyBaseApprovalPage from './pages/StudyBaseApproval'
import OrganizationsPage from './pages/Organizations'
import InstitutionApplicationsPage from './pages/InstitutionApplications'
console.log('OrganizationsPage loaded:', typeof OrganizationsPage)
import OrgSwitcherPage from './pages/OrgSwitcher'
import CommercialConfigPage from './pages/CommercialConfig'
import ReportsPage from './pages/Reports'
import ActivityApprovalsPage from './pages/ActivityApprovals'
import InstitutionPartnerPage from './pages/InstitutionPartner'
import CompanyPartnerPage from './pages/CompanyPartner'
import StorePartnerPage from './pages/StorePartner'
import GrowthVideoProductionPage from './pages/GrowthVideoProduction'
import VideoProductionPage from './pages/VideoProduction'
import WorkbenchPage from './pages/WorkbenchPage'
import ActivityReviewPage from './pages/ActivityReview'
import UnifiedAssetsPage from './pages/UnifiedAssets'
import PaintingVideoProductionPage from './pages/PaintingVideoProduction'
import VideoOrdersPage from './pages/VideoOrders'
import AnimationOrderPage from './pages/AnimationOrder'
import AiAnimationRecords from './pages/AiAnimationRecords'
import AIMarketUsersPage from './pages/AIMarketUsers'
import AIMarketCustomersPage from './pages/AIMarketCustomers'
import ShowcaseAdminPage from './pages/ShowcaseAdmin'
import PartnerApplicationsPage from './pages/PartnerApplications'
import LeadsUnified from './pages/LeadsUnified'
import GeoLookLeads from './pages/GeoLookLeads'
import CmsAgent from './components/CmsAgent'
import GeolookDashboard from './pages/GeolookDashboard'
import ProductionWorkOrderPage from './pages/ProductionWorkOrder'
import BatchTaskPage from './pages/BatchTask'
import AssetManagementPage from './pages/AssetManagement'
import ActivityPhotosPage from './pages/ActivityPhotos'
import ClaimCodeRedeemPage from './pages/ClaimCodeRedeem'
import ClaimCodesPage from './pages/ClaimCodes'
import BatchVideoProductionPage from './pages/BatchVideoProduction'
import AICampManagementPage from './pages/AICampManagement'
import PointsManagementPage from './pages/PointsManagement'
import LearningProgressPage from './pages/LearningProgress'
import PartnerLoginPage from './pages/PartnerLogin'
import StoreSalesPage from './pages/StoreSales'
import CourseSchedulePage from './pages/CourseSchedule'
import VerificationPage from './pages/Verification'
import GrowthPortfolioPage from './pages/GrowthPortfolio'
import ShareStatsPage from './pages/ShareStats'
import GrowthOverviewPage from './pages/GrowthOverview'
import VideoGenerationPage from './pages/VideoGeneration'
import VideoAnimationModule from './pages/VideoAnimationModule'
import ChildAssetsPage from './pages/ChildAssets'
import CustomersPage from './pages/Customers'
import ResearchActivitiesPage from './pages/ResearchActivities'
import CoursewarePage from './pages/Courseware'
import IPOperationsPage from './pages/IPOperations'
import InviteManagementPage from './pages/InviteManagement'
import WorkReviewPage from './pages/WorkReview'
import AnalyticsDashboardPage from './pages/AnalyticsDashboard'
import BatchImportPage from './pages/BatchImport'
import DataExportPage from './pages/DataExport'
import OperationLogsPage from './pages/OperationLogs'
import BatchNotificationPage from './pages/BatchNotification'
import GroupBuyManagePage from './pages/GroupBuyManage'
import FlashSaleManagePage from './pages/FlashSaleManage'
import RateManagePage from './pages/RateManage'
import StudyBaseManagePage from './pages/StudyBaseManage'

// 检测公开路由（领取码家长访问）
// 解析URL - 支持 /cms/page-name 和 /cms/?page=page-name 两种格式
const pathParts = window.location.pathname.split('/').filter(Boolean)
const isCMSPath = pathParts[0] === 'cms'
const pageFromPath = isCMSPath ? pathParts[1] : null
const urlParams = new URLSearchParams(window.location.search)
const preloadedCode = urlParams.get('code') || ''
const pageParam = urlParams.get('page') || pageFromPath

// ============================================================
// 角色解析
// ============================================================
const getStoredUser = () => {
  try {
    const raw = localStorage.getItem('cms_user')
    return raw ? JSON.parse(raw) : null
  } catch { return 'unified-login' }
}
const getUserRole = () => {
  const user = getStoredUser()
  return user?.role || null
}
const getUserInstitutionId = () => {
  const user = getStoredUser()
  return user?.institutionId || null
}
const isHQ = () => {
  const role = getUserRole()
  // admin, hq, manager, headquarters 等都视为总部用户
  return role === 'admin' || role === 'hq' || role === 'manager' || role === 'headquarters' || role === 'HQ'
}
const isOrg = () => getUserRole() === 'institution'

// ============================================================
// 套餐权限配置
// ============================================================
const PLANS = {
  FREE: 'free',
  PRO: 'pro',
  ENTERPRISE: 'enterprise'
}

// 套餐等级数值（用于比较）
const PLAN_LEVELS = {
  free: 1,
  'pro': 2,
  enterprise: 3
}

// 获取当前套餐
const getUserPlan = () => {
  const user = getStoredUser()
  return user?.plan || PLANS.FREE
}

// 检查套餐是否 >= 指定等级
const hasPlan = (requiredPlan) => {
  const userPlan = getUserPlan()
  const userLevel = PLAN_LEVELS[userPlan] || 0
  const requiredLevel = PLAN_LEVELS[requiredPlan] || 0
  return userLevel >= requiredLevel
}

// 套餐权限表（菜单ID -> 最低所需套餐）
// 命名映射：BASIC=免费版，STANDARD=专业版，PROFESSIONAL=企业版
// ENTERPRISE 暂时保留但实际不被 NEW_MENU_PERMISSIONS 使用
// const MENU_PERMISSIONS = {} // DEPRECATED: use NEW_MENU_PERMISSIONS

// 新版权限表（按政策定义）
const NEW_MENU_PERMISSIONS = {
  // 📊 基础功能 - 三版都有
  'hq-dashboard': PLANS.PRO,       // 数据总览 - 专业版+
  'data-overview': PLANS.FREE,         // 数据看板 - 免费版可用
  'analytics': PLANS.FREE,             // 数据分析 - 免费版可用
  'crm': PLANS.FREE,                   // 客户管理 - 免费版可用
  'orders': PLANS.FREE,                // 订单管理 - 免费版可用
  'learning-progress': PLANS.FREE,     // 学习进度 - 免费版可用
  
  // 👶 成长档案 - 三版都有
  'children': PLANS.FREE,
  'activities': PLANS.FREE,
  'timeline': PLANS.FREE,
  'growth-portfolio': PLANS.FREE,
  'child-assets': PLANS.FREE,
  
  // 🎬 视频制作 - 三版都有（免费版带水印）
  'growth-video-production': PLANS.FREE,   // 成长视频 - 所有版本（免费版带水印）
  'video-production': PLANS.FREE,          // 视频制作
  'batch-video-production': PLANS.FREE,    // 批量视频
  'painting-video-production': PLANS.FREE, // 画作动画
  'video-animation': PLANS.FREE,
  'music-library': PLANS.FREE,
  'unified-assets': PLANS.FREE,
  'video-orders': PLANS.FREE,
  'animation-order': PLANS.FREE,
  'work-order': PLANS.FREE,
  
  // 🔬 能力评估 - 免费版基础，标准版更多
  'assessments': PLANS.FREE,
  'growth-report': PLANS.FREE,
  'ai-growth-report': PLANS.PRO,       // AI成长报告 - 专业版+
  'radar-chart': PLANS.PRO,            // 雷达图 - 专业版+
  
  // 📢 营销工具 - 三版都有
  'wechat-management': PLANS.PRO,  // 独立小程序后台 - 企业版
  // 'wechat-marketing': PLANS.FREE,  // DEPRECATED
  // 'sms-marketing': PLANS.FREE,  // DEPRECATED
  'coupons': PLANS.FREE,
  'groupbuy': PLANS.FREE,
  'groupbuy-manage': PLANS.FREE,
  'recommend': PLANS.FREE,
  'claim-redeem': PLANS.FREE,
  'claim-codes': PLANS.FREE,
  
  // 🏕 活动 - 专业版+
  'research-activities': PLANS.PRO,    // 活动发布 - 专业版+
  'activities-manage': PLANS.PRO,
  'activity-approvals': PLANS.PRO,
  'activity-photos': PLANS.FREE,           // 活动素材查看 - 免费版
  
  // 💰 佣金管理 - 专业版+（专业版3人，企业版无限）
  'sales-commission': PLANS.PRO,
  'profit-sharing': PLANS.PRO,
  'partner-performance': PLANS.PRO,
  'partner-commissions': PLANS.PRO,
  'base-referral': PLANS.PRO,
  
  // 🤝 合伙人管理 - 专业版+
  'invite-management': PLANS.PRO,
  'institution-partner': PLANS.PRO,
  'company-partner': PLANS.PRO,
  'store-partner': PLANS.PRO,
  'store-sales': PLANS.PRO,
  'store-settlements': PLANS.PRO,
  'regional-agents': PLANS.PRO,
  
  // 📦 产品管理 - 三版都有
  'products': PLANS.FREE,                  // 产品列表 - 免费版可用
  'flashsale-manage': PLANS.FREE,
  'rate-manage': PLANS.FREE,
  
  // 🏢 机构运营 - 企业版
  'bases': PLANS.PRO,              // 基地管理 - 企业版
  'organizations': PLANS.PRO,      // 机构管理 - 企业版
  'institution-applications': PLANS.PRO,
  'studybase-manage': PLANS.PRO,
  'studybase-approval': PLANS.PRO,
  'course-schedule': PLANS.PRO,
  'verification': PLANS.PRO,
  
  // 🎯 IP运营/品牌 - 企业版
  'ip-operations': PLANS.PRO,
  'hq-content': PLANS.PRO,
  
  // ⚙️ SaaS体系 - 专业版+
  'commercial': PLANS.PRO,
  'partners': PLANS.PRO,
  
  // 📚 课件中心
  'courseware': PLANS.PRO,             // AI创作营课件 - 专业版+
  'courseware-upload': PLANS.PRO,  // 课件上传 - 企业版
  
  // 🎨 AI创作营
  'ai-camp-management': PLANS.PRO,     // 创作营管理 - 专业版+
  'work-review': PLANS.PRO,
  
  // 📊 学习中心
  'ai-edit': PLANS.FREE,
  'media': PLANS.FREE,
  'effects': PLANS.FREE,
  'tts': PLANS.FREE,
  'subtitle': PLANS.FREE,
  'production': PLANS.FREE,
  
  // 📋 系统工具
  'batch-import': PLANS.PRO,
  'data-export': PLANS.PRO,
  'batch-notification': PLANS.PRO,
  'operation-logs': PLANS.PRO,
  
  // 📈 数据报表
  'analytics-dashboard': PLANS.FREE,
  'reports': PLANS.FREE,
  
  // 👤 会员/积分
  'members': PLANS.FREE,
  'points': PLANS.FREE,
  'points-management': PLANS.FREE,
  'customers': PLANS.FREE,
  
  // 💳 财务
  'finance': PLANS.FREE,
  'financial-management': PLANS.FREE,
  
  // 🏠 基地/门店
  'bases-management': PLANS.PRO,
  
  // 📱 小程序
  
  // 🔐 入驻申请 - 面向所有人
  'institution-register': PLANS.FREE,
  'base-register': PLANS.FREE,
  'regional-agent-register': PLANS.FREE,
  'partner-apply': PLANS.FREE,
}

// 检查菜单是否有权限（全部可见，无权限时加锁）
const canViewMenu = (menuId) => {
  // HQ 和 机构用户检查套餐权限
  if (isHQ() || isOrg()) {
    const requiredPlan = NEW_MENU_PERMISSIONS[menuId]
    if (!requiredPlan) return true // 未配置的菜单默认可见
    return hasPlan(requiredPlan)
  }
  
  // 推广员/代理：根据套餐权限
  const requiredPlan = NEW_MENU_PERMISSIONS[menuId]
  if (!requiredPlan) return true
  return hasPlan(requiredPlan)
}

// 根据角色确定默认页
const getDefaultPage = () => {
  const role = getUserRole()
  // CMS 后台是总部管理入口，所有角色默认打开 hq-dashboard
  // 机构/代理/推广员的独立入口在 /institution/ 或各自的管理后台
  if (role === 'admin' || role === 'hq' || role === 'manager' || role === 'headquarters' || role === 'HQ') return 'hq-dashboard'
  return 'hq-dashboard'
}

// 版本名映射（常量名→显示名）
const PLAN_NAMES = {
  'basic': '免费版',
  'standard': '专业版',
  'professional': '企业版'
}

// 获取需要升级到的版本显示名
const getRequiredPlanName = (menuId) => {
  const requiredPlan = NEW_MENU_PERMISSIONS[menuId]
  return PLAN_NAMES[requiredPlan] || requiredPlan || '更高版本'
}

// QR码动态加载组件（避免 qrcode.react 打包进主 bundle）
function QrCodeWrapper({ value, size, level }) {
  const [QRComp, setQRComp] = useState(null)
  useEffect(() => {
    let cancelled = false
    import('qrcode.react').then(m => {
      if (!cancelled) setQRComp(() => m.QRCodeSVG)
    })
    return () => { cancelled = true }
  }, [])
  if (!QRComp) return <div style={{width:size,height:size,display:'flex',alignItems:'center',justifyContent:'center',color:'#999',fontSize:13}}>加载中...</div>
  return <QRComp value={value} size={size} level={level} />
}

export default function App() {
  const [currentPage, setCurrentPageState] = useState(
    urlParams.get('code') ? 'claim-redeem' : (pageParam || getDefaultPage())
  )
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)
  const [upgradeInfo, setUpgradeInfo] = useState({ plan: '', feature: '' })
  const [showAiAdvisor, setShowAiAdvisor] = useState(false)

  // 自定义setState，同时更新URL
  const setCurrentPage = (page) => {
    setCurrentPageState(page)
    // 更新URL但不添加历史记录
    const newUrl = page ? `/cms/?page=${page}` : '/cms/'
    window.history.replaceState({}, '', newUrl)
  }
  
  // 被锁菜单点击处理
  const handleLockedMenu = (menuId, featureName) => {
    const requiredPlan = NEW_MENU_PERMISSIONS[menuId]
    const planName = PLAN_NAMES[requiredPlan] || requiredPlan || '更高版本'
    setShowUpgradeModal(true)
    setUpgradeInfo({ plan: planName, feature: featureName || '' })
  }

  // 监听快捷入口点击事件
  useEffect(() => {
    const handleNavigate = (e) => {
      if (e.detail && setCurrentPage) {
        setCurrentPage(e.detail)
      }
    }
    window.addEventListener('navigate', handleNavigate)
    return () => window.removeEventListener('navigate', handleNavigate)
  }, [])

  const user = getStoredUser()
  const role = getUserRole()
  const coursewareEnabled = localStorage.getItem('cms_courseware') === '1'

  // 公开页面列表
  // 合作伙伴工作台需要登录
  const partnerStorePageNames = ['partner-store', 'base-dashboard']
  
  const publicPageNames = ['partner-register', 'partner-apply', 'institution-register', 'base-register', 'regional-agent-register', 'claim-redeem', 'partner-center', 'agent-center']
  
  // 公开页面列表 - 基地相关页面
  const basePages = ['base-login', 'base-dashboard', 'base-register']
  
  // 检查是否是基地相关页面请求
  // pageParam already defined above
  const isBasePage = basePages.includes(pageParam)
  
  // 只有在访问基地专属页面时才检查基地登录
  if (isBasePage) {
    const baseToken = localStorage.getItem('base_token')
    const baseId = localStorage.getItem('base_id')
    if (baseToken && baseId && !role) {
      return <BaseDashboardPage />
    }
  }
  
  // 未登录且不是公开页面 → 跳转登录
  if (!role && !urlParams.get('code') && !publicPageNames.includes(pageParam)) {
    return <UnifiedLoginPage />
  }

  const loginRoutes = {
    'base-login': UnifiedLoginPage,
    'base-dashboard': BaseDashboardPage,
    'channel-login': ChannelLoginPage,
    'partner-unified-login': PartnerUnifiedLogin,
    'org-login': OrganizationLoginPage,
  }

  // 公开路由（无需登录）
  const publicRoutes = {
    'partner-register': PartnerRegisterPage,
        'partner-apply': PartnerApplyPage,
    'partner-center': PartnerCenterPage,
    'partner-store': PartnerStorePage,
    'institution-register': InstitutionRegisterPage,
    'base-register': BaseRegisterPage,
    'regional-agent-register': RegionalAgentRegisterPage,
    'agent-center': AgentCenterPage,
    'claim-redeem': ClaimCodeRedeemPage,
        'claim-codes': ClaimCodesPage,
  }

  const renderPage = () => {
    // 公开路由
    if (publicRoutes[currentPage]) {
      const PublicComp = publicRoutes[currentPage]
      return <PublicComp />
    }

    // 登录路由
    if (loginRoutes[currentPage]) {
      const LoginComp = loginRoutes[currentPage]
      return <LoginComp />
    }

    // ============================================================
    // HQ 可访问所有页面（角色校验在菜单层已过滤）
    // ============================================================
    if (isHQ()) {
      switch(currentPage) {
        case 'hq-miniapp-overview': return <HQMiniappOverview />
        case 'hq-banners': return <BannerManage />
        case 'hq-miniapp-config': return <MiniAppConfig />
        case 'inst-miniapp-config': return <InstMiniappConfigPage />
        case 'inst-banners': return <InstBannerManagePage />
        case 'hq-dashboard': return <HQDashboardPage />
        case 'dashboard': return <DashboardPage />
        case 'assets': return <AssetsPage />
        case 'asset-management': return <AssetManagementPage />
        case 'growth-video-production': return <GrowthVideoProductionPage />
        case 'video-production': return <WorkbenchPage />
        case 'music-library': return <MusicLibraryPage />
        case 'unified-assets': return <UnifiedAssetsPage />
        case 'video-animation': return <VideoAnimationModule />
        case 'painting-video-production': return <PaintingVideoProductionPage />
        case 'video-orders': return <VideoOrdersPage />
        case 'ai-edit': return <AISmartEditPage />
        case 'media': return <MediaLibraryPage />
        case 'effects': return <EffectsLibraryPage />
        case 'tts': return <TTSPage />
        case 'subtitle': return <SubtitlePage />
        case 'production': return <ProductionPage />
        case 'analytics': return <AnalyticsPage />
        case 'ai-square-data': return <AIMarketUsersPage />
        case 'ai-market-customers': return <AIMarketCustomersPage />
        case 'showcase-admin': return <ShowcaseAdminPage />
        case 'partner-applications': return <PartnerApplicationsPage />
        case 'sms': return <SmsMarketingPage />
        // case 'sms-marketing': return <SmsMarketingPage />
        case 'courseware-upload': return <CoursewareUploadPage />
        case 'wechat': return <WechatManagementPage />
        case 'coupons': return <CouponsPage />
        case 'groupbuy': return <GroupBuyPage />
        case 'recommend': return <RecommendPage />
        case 'activities': return <StudyActivitiesPage />
        case 'training': return <TrainingPage />
        case 'crm': return <CRMPage />
        case 'orders': return <OrdersPage />
        case 'products': return <ProductsPage />
        case 'finance': return <FinancePage />
        case 'members': return <MembersPage />
        case 'points': return <PointsPage />
        case 'partners': return <PartnersPage />
        case 'invite-management': return <InviteManagementPage />
        case 'partner-apply': return <PartnerApplyPage />
        case 'contracts': return <ContractsPage />
        case 'partner-contracts': return <PartnerContractPage />
        case 'growth-portal': return <GrowthPortalPage />
        case 'partner-center': return <PartnerCenterPage />
        case 'partner-store': return <PartnerStorePage />
        case 'salesperson-overview': return <SalespersonOverviewPage />
        case 'partner-commissions': return <PartnerCommissions />
        case 'base-referral': return <BaseReferral />
        case 'financial-management': return <FinancialManagement />
        case 'institution-register': return <InstitutionRegisterPage />
        case 'base-register': return <BaseRegisterPage />
        case 'regional-agent-register': return <RegionalAgentRegisterPage />
        case 'regional-agents': return <RegionalAgentsPage />
        case 'sales-commission-config': return <SalesCommissionConfigPage />
        case 'institution-partner':
        case 'institution-partner-page': return <InstitutionPartnerPage />
        case 'company-partner': return <CompanyPartnerPage />
        case 'store-partner': return <StorePartnerPage />
        case 'channels': return <ChannelsPage />
        case 'profit-sharing': return <ProfitSharingPage />
        case 'bases': return <BasesPage />
        case 'institution-applications': return <InstitutionApplicationsPage />
        case 'leads-management': return <LeadsUnified />
            case 'geolook-leads': return <GeoLookLeads />
            case 'geolook-dashboard': return <GeolookDashboard />
        case 'base-login': return <BaseLoginPage />
        case 'organizations': return <OrganizationsPage />
        case 'org-switcher': return <OrgSwitcherPage />
        case 'commercial': return <CommercialConfigPage />
        case 'reports': return <ReportsPage />
        case 'approvals': return <ActivityApprovalsPage />
        case 'animation-order': return <AnimationOrderPage />
        case 'ai-animation-records': return <AiAnimationRecords />
        case 'work-order': return <ProductionWorkOrderPage />
        case 'batch-task': return <BatchTaskPage />
        case 'activity-photos': return <ActivityPhotosPage />
        case 'child-assets': return <ChildAssetsPage />
        case 'batch-video-production': return <BatchVideoProductionPage />
        case 'ai-camp-management': return <AICampManagementPage />
        case 'points-management': return <PointsManagementPage />
        case 'learning-progress': return <LearningProgressPage />
        case 'partner-login': return <PartnerLoginPage />
        case 'store-sales': return <StoreSalesPage />
        case 'store-settlements': return <StoreSettlements />
        case 'course-schedule': return <CourseSchedulePage />
        case 'verification': return <VerificationPage />
        case 'growth-portfolio': return <GrowthPortfolioPage />
        case 'share-stats': return <ShareStatsPage />
        case 'growth-overview': return <GrowthOverviewPage />
        case 'video-generation': return <VideoGenerationPage />
        case 'customers': return <CustomersPage />
        case 'research-activities': return <ResearchActivitiesPage />
        // case 'wechat-marketing': return <WechatMarketingPage />
        case 'hq-content': return <HQContentPage />
        case 'ip-operations': return <IPOperationsPage />
        case 'courseware': return <CoursewarePage />
        case 'work-review': return <WorkReviewPage />
        case 'analytics-dashboard': return <AnalyticsDashboardPage />
        case 'batch-import': return <BatchImportPage />
        case 'data-export': return <DataExportPage />
        case 'operation-logs': return <OperationLogsPage />
        case 'batch-notification': return <BatchNotificationPage />
        case 'groupbuy-manage': return <GroupBuyManagePage />
        case 'flashsale-manage': return <FlashSaleManagePage />
        case 'rate-manage': return <RateManagePage />
        case 'studybase-manage': return <StudyBaseManagePage />
        case 'studybase-approval': return <StudyBaseApprovalPage />
                default: return <HQDashboardPage />
      }
    }

    // ============================================================
    // 机构用户受限菜单
    // ============================================================
      
      if (isOrg() && !isCMSPath) {
      switch(currentPage) {
        case 'dashboard': return <DashboardPage />
        case 'child-assets': return <ChildAssetsPage />
        case 'growth-video-production': return <GrowthVideoProductionPage />
        case 'video-production': return <WorkbenchPage />
        case 'music-library': return <MusicLibraryPage />
        case 'unified-assets': return <UnifiedAssetsPage />
        case 'video-animation': return <VideoAnimationModule />
        case 'orders': return <OrdersPage />
        case 'finance': return <FinancePage />
        case 'members': return <MembersPage />
        case 'activities': return <StudyActivitiesPage />
        case 'products': return <ProductsPage />
        case 'analytics': return <AnalyticsPage />
        case 'ai-square-data': return <AIMarketUsersPage />
        case 'learning-progress': return <LearningProgressPage />
        case 'coupons': return <CouponsPage />
        // case 'wechat-marketing': return <WechatMarketingPage />
        case 'hq-content': return <HQContentPage />
        case 'courseware': return coursewareEnabled ? <CoursewarePage /> : (
          <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
            <p>您的机构暂未开通课件中心</p>
            <p style={{ fontSize: 12, color: '#aaa' }}>请联系客服申请开通</p>
          </div>
        )
        case 'claim-redeem': return <ClaimCodeRedeemPage />
        case 'batch-video': return <BatchVideoProductionPage />
        case 'contracts': return <PartnerContractPage />
        case 'partner-center': return <PartnerCenterPage />
        case 'partner-store': return <PartnerStorePage />
        case 'growth-portal': return <GrowthPortalPage />
        default: return <DashboardPage />
      }
    }

    return <UnifiedLoginPage />
  }

  // ============================================================
  // HQ 专属菜单
  // ============================================================
  const HQMenu = () => (
    <>
      {/* 📊 数据中心 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 12 }}>📊 数据中心</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="总部仪表盘" active={currentPage === 'hq-dashboard'} onClick={() => setCurrentPage('hq-dashboard')} />
        <MenuItem label="数据概览" active={currentPage === 'dashboard'} onClick={() => setCurrentPage('dashboard')} />
        <MenuItem label="数据分析" active={currentPage === 'analytics'} onClick={() => setCurrentPage('analytics')} />
        <MenuItem label="客户管理" active={currentPage === 'customers'} onClick={() => setCurrentPage('customers')} />
        <MenuItem label="订单管理" active={currentPage === 'orders'} onClick={() => setCurrentPage('orders')} />
        <MenuItem label="学习进度" active={currentPage === 'learning-progress'} onClick={() => setCurrentPage('learning-progress')} />
        {getUserRole() === 'admin' && <MenuItem label="AI广场数据" active={currentPage === 'ai-square-data'} onClick={() => setCurrentPage('ai-square-data')} />}
        {getUserRole() === 'admin' && <MenuItem label="AI广场客户" active={currentPage === 'ai-market-customers'} onClick={() => setCurrentPage('ai-market-customers')} />}
        {getUserRole() === 'admin' && <MenuItem label="作品墙管理" active={currentPage === 'showcase-admin'} onClick={() => setCurrentPage('showcase-admin')} />}
        {getUserRole() === 'admin' && <MenuItem label="合作申请" active={currentPage === 'partner-applications'} onClick={() => setCurrentPage('partner-applications')} />}
  {getUserRole() === 'admin' && <MenuItem label="线索管理" active={currentPage === 'leads-management'} onClick={() => setCurrentPage('leads-management')} />}
        {getUserRole() === 'admin' && <MenuItem label="品牌管家" active={false} onClick={() => window.open('https://ai.boxiaotu.cn/geolook/', '_blank')} />}
        
      <CmsAgent />
      </div>

      {/* 🎬 AI创作中心 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>🎬 AI创作中心</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="孩子资产" active={currentPage === 'child-assets'} onClick={() => setCurrentPage('child-assets')} />
        <MenuItem label="素材库" active={currentPage === 'unified-assets'} onClick={() => setCurrentPage('unified-assets')} />
        <MenuItem label="🎬 视频工作台" active={currentPage === 'video-production'} onClick={() => setCurrentPage('video-production')} />
        <MenuItem label="视频制作" active={currentPage === 'growth-video-production' || currentPage === 'video-animation'} onClick={() => setCurrentPage('growth-video-production')} />
        <MenuItem label="音乐库" active={currentPage === 'music-library'} onClick={() => setCurrentPage('music-library')} />
        <MenuItem label="批量视频制作" active={currentPage === 'batch-video-production'} onClick={() => setCurrentPage('batch-video-production')} />
        <MenuItem label="创作统计" active={currentPage === 'ai-camp-management'} onClick={() => setCurrentPage('ai-camp-management')} />
        <MenuItem label="AI动画记录" active={currentPage === 'ai-animation-records'} onClick={() => setCurrentPage('ai-animation-records')} />
        <MenuItem label="分享统计" active={currentPage === 'share-stats'} onClick={() => setCurrentPage('share-stats')} />
        <MenuItem label="成长档案概况" active={currentPage === 'growth-overview'} onClick={() => setCurrentPage('growth-overview')} />
      </div>

      {/* ⚙️ 系统工具 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>⚙️ 系统工具</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="批量导入" active={currentPage === 'batch-import'} onClick={() => setCurrentPage('batch-import')} />
        <MenuItem label="数据导出" active={currentPage === 'data-export'} onClick={() => setCurrentPage('data-export')} />
        <MenuItem label="批量通知" active={currentPage === 'batch-notification'} onClick={() => setCurrentPage('batch-notification')} />
        <MenuItem label="操作日志" active={currentPage === 'operation-logs'} onClick={() => setCurrentPage('operation-logs')} />
      </div>

      {/* 💰 财务与会员 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>💰 财务与会员</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="财务管理" active={currentPage === 'financial-management'} onClick={() => setCurrentPage('financial-management')} />
        <MenuItem label="会员管理" active={currentPage === 'members'} onClick={() => setCurrentPage('members')} />
        <MenuItem label="积分管理" active={currentPage === 'points-management'} onClick={() => setCurrentPage('points-management')} />

      </div>

      {/* 📚 课件中心 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>📚 课件中心</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="课件上传" active={currentPage === 'courseware-upload'} onClick={() => setCurrentPage('courseware-upload')} />
        <MenuItem label="课件中心" active={currentPage === 'courseware'} onClick={() => setCurrentPage('courseware')} />
      </div>

      {/* 📚 学习中心 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>📚 学习中心</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="AI创作营" active={currentPage === 'ai-camp-management'} onClick={() => setCurrentPage('ai-camp-management')} />
        <MenuItem label="AI动画订单" active={currentPage === 'animation-order'} onClick={() => setCurrentPage('animation-order')} />
      </div>

      {/* 🗺️ 线上推广体系 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>🗺️ 线上推广体系</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="区域代理" active={currentPage === 'regional-agents'} onClick={() => setCurrentPage('regional-agents')} />
        <MenuItem label="线上推广员" active={currentPage === 'partners'} onClick={() => setCurrentPage('partners')} />
        <MenuItem label="佣金管理" active={currentPage === 'partner-commissions'} onClick={() => setCurrentPage('partner-commissions')} />
      </div>

      {/* 🏪 门店管理 */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="渠道管理" active={currentPage === 'channels'} onClick={() => setCurrentPage('channels')} />
        <MenuItem label="门店结算" active={currentPage === 'store-settlements'} onClick={() => setCurrentPage('store-settlements')} />
        <MenuItem label="基地推荐" active={currentPage === 'base-referral'} onClick={() => setCurrentPage('base-referral')} />
      </div>

      {/* 📱 小程序管理 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>📱 小程序管理</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="机构小程序总览" active={currentPage === 'hq-miniapp-overview'} onClick={() => setCurrentPage('hq-miniapp-overview')} />
        <MenuItem label="审核开关" active={currentPage === 'hq-miniapp-config'} onClick={() => setCurrentPage('hq-miniapp-config')} />
      </div>

      {/* 🏢 合作伙伴 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>🏢 合作伙伴</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="基地管理" active={currentPage === 'bases' || currentPage === 'base-dashboard'} onClick={() => setCurrentPage('bases')} />
        <MenuItem label="机构管理" active={currentPage === 'organizations'} onClick={() => setCurrentPage('organizations')} />
        <MenuItem label="合作伙伴登录" active={currentPage === 'base-login'} onClick={() => setCurrentPage('base-login')} />
        <MenuItem label="合作伙伴工作台" active={currentPage === 'partner-store'} onClick={() => setCurrentPage('partner-store')} />
        <MenuItem label="业务员总览" active={currentPage === 'salesperson-overview'} onClick={() => setCurrentPage('salesperson-overview')} />
      </div>



      {/* 📄 合同管理 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>📄 合同管理</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="合同管理" active={currentPage === 'contracts'} onClick={() => setCurrentPage('contracts')} />
      </div>

      {/* 📋 资料中心 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>📋 资料中心</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="机构合作方案" active={false} onClick={() => window.open('/storage/cooperation-plan.pdf', '_blank')} />
      </div>



      {/* 📬 发布管理 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>📬 发布管理</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="基地活动审核" active={currentPage === 'studybase-approval'} onClick={() => setCurrentPage('studybase-approval')} />
      </div>

      {/* 📦 内容管理 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>📦 内容管理</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="产品列表" active={currentPage === 'products'} onClick={() => canViewMenu("products") ? setCurrentPage('products') : handleLockedMenu("products", "产品列表")} locked={!canViewMenu("products") && !isHQ()} />
        <MenuItem label="活动" active={currentPage === 'research-activities'} onClick={() => setCurrentPage('research-activities')} />
        <MenuItem label="活动素材" active={currentPage === 'activity-photos'} onClick={() => setCurrentPage('activity-photos')} />
        <MenuItem label="领取码兑换" active={currentPage === 'claim-redeem'} onClick={() => setCurrentPage('claim-redeem')} />
        <MenuItem label="领取码管理" active={currentPage === 'claim-codes'} onClick={() => canViewMenu('claim-codes') ? setCurrentPage('claim-codes') : handleLockedMenu('claim-codes', '领取码管理')} />
      </div>

      {/* 📚 成长档案系统 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>📚 成长档案系统</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="成长档案" active={currentPage === 'growth-portal'} onClick={() => setCurrentPage('growth-portal')} />
      </div>
    </>
  )

  // 机构专属菜单（已弃用，保留为参考）
  const OrgMenu = () => (
    <>
      {/* 数据 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 12 }}>数据</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="数据概览" active={currentPage === 'dashboard'} onClick={() => setCurrentPage('dashboard')} />
        <MenuItem label="订单管理" active={currentPage === 'orders'} onClick={() => setCurrentPage('orders')} />
      </div>

      {/* 视频工作台 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>视频工作台</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="成长视频制作" active={currentPage === 'growth-video-production'} onClick={() => setCurrentPage('growth-video-production')} />
        <MenuItem label="批量视频制作" active={currentPage === 'batch-video'} onClick={() => setCurrentPage('batch-video')} />
      </div>

      {/* 合作伙伴 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>合作伙伴</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="合同申请" active={currentPage === 'contracts'} onClick={() => setCurrentPage('contracts')} />
      </div>

      {/* 成长档案系统 */}
      <div style={{ color: '#888', fontSize: 11, marginBottom: 6, marginTop: 16 }}>成长档案系统</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        <MenuItem label="成长档案" active={currentPage === 'growth-portal'} onClick={() => setCurrentPage('growth-portal')} />
      </div>
    </>
  )

  const handleLogout = () => {
    // 清除CMS登录信息
    Object.keys(localStorage).forEach(k => {
      if (k.startsWith('cms_') || k.startsWith('boxiaotu_')) {
        localStorage.removeItem(k)
      }
    })
    // 清除基地登录信息
    localStorage.removeItem('base_token')
    localStorage.removeItem('base_id')
    localStorage.removeItem('base_info')
    window.location.reload()
  }

  // 公开页面直接显示，不使用CMS布局
  if (publicPageNames.includes(currentPage)) {
    return renderPage()
  }

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      {/* 侧边栏 */}
      <div style={{ width: 280, background: '#001529', display: 'flex', flexDirection: 'column' }}>
        {/* 头部 */}
        <div style={{ padding: 16, borderBottom: '1px solid #333' }}>
          <h3 style={{ color: '#fff', margin: '0 0 4px' }}>🐰 博小兔企业大脑</h3>
          <div style={{ color: '#888', fontSize: 11 }}>
            {isHQ() && <span>总部管理</span>}
            {isOrg() && <span>机构管理 · {user?.institutionName || ''}</span>}
          </div>
        </div>

        {/* 菜单区域 */}
        <div style={{ flex: 1, padding: 12, overflowY: 'auto' }}>
          {isOrg() ? <OrgMenu /> : <HQMenu />}
        </div>

        {/* 底部 */}
        <div style={{ padding: 12, borderTop: '1px solid #333' }}>
          <div style={{ color: '#888', fontSize: 12, marginBottom: 8 }}>
            {user?.username} · {isHQ() ? '总部' : '机构'}
          </div>
          <button onClick={handleLogout} style={{ width: '100%', padding: '8px', background: 'transparent', color: '#ccc', border: '1px solid #333', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>
            退出登录
          </button>

        </div>
      </div>

      <main style={{ flex: 1, overflow: 'auto', background: '#f5f5f5', padding: 24 }}>
        {renderPage()}
      </main>
      <UpgradeModal show={showUpgradeModal} info={upgradeInfo} onClose={() => setShowUpgradeModal(false)} />
      <AiAdvisorBubble show={showAiAdvisor} onToggle={() => setShowAiAdvisor(v => !v)} />
    </div>
  )
}

// ============================================================
// 升级弹窗组件
// ============================================================
function UpgradeModal({ show, info, onClose }) {
  if (!show) return null
  
  const API = 'https://api.boxiaotu.cn/cms/api'
  const [loading, setLoading] = useState(false)
  const [orderData, setOrderData] = useState(null)
  const [paid, setPaid] = useState(false)
  const pollRef = useRef(null)
  
  // 版本配置
  const ALL_PLANS = [
    {
      id: 'free', name: '免费版', price: 0,
      features: ['50个孩子档案', '30次活动/月', '10GB存储', '视频水印', '成长视频制作'],
      limit: true
    },
    {
      id: 'pro', name: '专业版', price: 299,
      features: ['200个孩子档案', '100次活动/月', '50GB存储', '无水印视频', 'AI成长报告', '活动管理', '推广员体系'],
      hot: true
    },
    {
      id: 'enterprise', name: '企业版', price: 999,
      features: ['无限孩子档案', '无限活动', '200GB存储', '品牌定制', '微信公众号管理', '总部管理后台', '区域代理', '优先客服'],
      recommend: true
    }
  ]
  
  // 获取当前用户版本
  const user = (() => { try { return JSON.parse(localStorage.getItem('cms_user')) } catch {} return null })()
  const currentPlan = user?.plan || 'free'
  const currentLevel = { free: 1, pro: 2, enterprise: 3 }[currentPlan] || 1
  
  // 轮询支付结果
  useEffect(() => {
    if (orderData && orderData.qrCode && !paid) {
      pollRef.current = setInterval(async () => {
        try {
          const token = localStorage.getItem('cms_token') ||
            (() => { try { return JSON.parse(localStorage.getItem('cms_user')).token } catch {} return '' })()
          const res = await fetch(API + '/plan/me', {
            headers: { 'Authorization': 'Bearer ' + token }
          })
          const data = await res.json()
          if (data.success && data.user) {
            const newLevel = { free: 1, pro: 2, enterprise: 3 }[data.user.plan] || 1
            if (newLevel > currentLevel) {
              setPaid(true)
              clearInterval(pollRef.current)
            }
          }
        } catch {}
      }, 5000)
    }
    return () => { if (pollRef.current) clearInterval(pollRef.current) }
  }, [orderData, paid])
  
  const handleUpgrade = async (targetPlanId) => {
    setLoading(true)
    try {
      const token = localStorage.getItem('cms_token') ||
        (() => { try { return JSON.parse(localStorage.getItem('cms_user')).token } catch {} return '' })()
      const res = await fetch(API + '/plan/upgrade', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ targetPlan: targetPlanId })
      })
      const data = await res.json()
      if (data.success) {
        setOrderData(data.data)
      } else {
        alert(data.error || '升级失败，请联系客服')
      }
    } catch (e) {
      alert('网络错误，请稍后重试')
    }
    setLoading(false)
  }
  
  const handleClose = () => {
    if (pollRef.current) clearInterval(pollRef.current)
    setOrderData(null)
    setPaid(false)
    onClose()
  }
  
  // 支付成功页
  if (paid) {
    return (
      <div style={modalOverlay} onClick={handleClose}>
        <div style={modalBox} onClick={e => e.stopPropagation()}>
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 64, marginBottom: 12 }}>🎉</div>
            <h2 style={{ margin: '0 0 8px', fontSize: 20, color: '#389e0d' }}>升级成功！</h2>
            <p style={{ fontSize: 14, color: '#666', lineHeight: 1.6 }}>
              您的账户已升级为 <strong>{orderData?.planName || '高级版本'}</strong><br/>
              有效期至：{orderData?.expireAt ? new Date(orderData.expireAt).toLocaleDateString('zh-CN') : '长期'}
            </p>
            <button onClick={handleClose} style={{
              marginTop: 16, padding: '10px 40px', border: 'none', borderRadius: 8,
              fontSize: 15, fontWeight: 600, color: '#fff', cursor: 'pointer',
              background: 'linear-gradient(135deg, #52c41a, #389e0d)'
            }}>开始使用</button>
          </div>
        </div>
      </div>
    )
  }
  
  // 下单成功 → 展示二维码
  if (orderData && orderData.qrCode) {
    return (
      <div style={modalOverlay} onClick={handleClose}>
        <div style={{ ...modalBox, textAlign: 'center' }} onClick={e => e.stopPropagation()}>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#333', marginBottom: 16 }}>
            微信扫码支付
          </div>
          <div style={{
            display: 'inline-block', padding: 16, background: '#fff', borderRadius: 12,
            border: '2px solid #f0f0f0', marginBottom: 12
          }}>
            <QrCodeWrapper value={orderData.qrCode} size={200} level="M" />
          </div>
          <p style={{ fontSize: 13, color: '#666', lineHeight: 1.8, marginBottom: 4 }}>
            请使用微信扫描二维码完成支付<br/>
            <strong style={{ color: '#d46b08', fontSize: 16 }}>¥{orderData.amount}</strong>
            {'　｜　'}{orderData.planName}
          </p>
          <p style={{ fontSize: 11, color: '#999' }}>
            订单号：{orderData.orderNo}　二维码有效期2小时
          </p>
          <div style={{ marginTop: 12, display: 'flex', gap: 12, justifyContent: 'center' }}>
            <button onClick={handleClose} style={{
              padding: '8px 24px', border: '1px solid #d9d9d9', borderRadius: 8,
              background: '#fff', cursor: 'pointer', fontSize: 14
            }}>取消</button>
            <a href={orderData.qrCode} style={{
              padding: '8px 24px', border: 'none', borderRadius: 8,
              background: 'linear-gradient(135deg, #fa8c16, #d46b08)',
              color: '#fff', cursor: 'pointer', fontSize: 14, textDecoration: 'none'
            }} target="_blank" rel="noreferrer">打开微信</a>
          </div>
        </div>
      </div>
    )
  }
  
  // 下单成功但无二维码（fallback人工转账）
  if (orderData && orderData.paymentInfo) {
    return (
      <div style={modalOverlay} onClick={handleClose}>
        <div style={modalBox} onClick={e => e.stopPropagation()}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>⚠️</div>
            <h2 style={{ margin: '0 0 4px', fontSize: 18, color: '#333' }}>在线支付暂时不可用</h2>
            <p style={{ fontSize: 13, color: '#999', margin: 0 }}>请联系客服完成升级</p>
          </div>
          <div style={{ background: '#fff7e6', borderRadius: 12, padding: 16, marginBottom: 20 }}>
            <p style={{ fontSize: 12, color: '#666', lineHeight: 1.8 }}>
              订单号：{orderData.orderNo}<br/>
              金额：¥{orderData.amount}<br/>
              有效期：{new Date(orderData.expireAt).toLocaleDateString('zh-CN')}<br/>
            </p>
            <pre style={{ fontSize: 11, color: '#555', background: '#f0f0f0', padding: 12, borderRadius: 8, whiteSpace: 'pre-wrap' }}>
              {orderData.paymentInfo}
            </pre>
          </div>
          <div style={{ fontSize: 11, color: '#bbb', textAlign: 'center' }}>
            <span style={{ cursor: 'pointer' }} onClick={handleClose}>关闭</span>
          </div>
        </div>
      </div>
    )
  }
  
  // 默认：版本对比 + 升级选择
  return (
    <div style={modalOverlay} onClick={handleClose}>
      <div style={{ ...modalBox, maxWidth: 720 }} onClick={e => e.stopPropagation()}>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <h2 style={{ margin: '0 0 4px', fontSize: 20, color: '#333' }}>选择升级版本</h2>
          <p style={{ fontSize: 13, color: '#999', margin: 0 }}>当前版本：{ALL_PLANS.find(p => p.id === currentPlan)?.name || '免费版'}</p>
        </div>
        
        <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
          {ALL_PLANS.map(plan => {
            const isCurrent = plan.id === currentPlan
            const canUpgrade = currentLevel < ({ free: 1, pro: 2, enterprise: 3 }[plan.id] || 1)
            
            return (
              <div key={plan.id} style={{
                flex: '1 1 200px', minWidth: 180, maxWidth: 320,
                borderRadius: 12, padding: 20,
                border: isCurrent ? '2px solid #52c41a' : '1px solid #f0f0f0',
                background: isCurrent ? '#f6ffed' : '#fff',
                position: 'relative'
              }}>
                {plan.hot && (
                  <div style={{
                    position: 'absolute', top: -8, right: 16,
                    background: 'linear-gradient(135deg, #fa8c16, #d46b08)',
                    color: '#fff', fontSize: 11, fontWeight: 600,
                    padding: '2px 10px', borderRadius: 10
                  }}>推荐</div>
                )}
                {plan.recommend && (
                  <div style={{
                    position: 'absolute', top: -8, right: 16,
                    background: 'linear-gradient(135deg, #722ed1, #531dab)',
                    color: '#fff', fontSize: 11, fontWeight: 600,
                    padding: '2px 10px', borderRadius: 10
                  }}>旗舰</div>
                )}
                
                <div style={{ fontSize: 16, fontWeight: 700, color: '#333', marginBottom: 4 }}>{plan.name}</div>
                <div style={{ marginBottom: 12 }}>
                  <span style={{ fontSize: 28, fontWeight: 700, color: plan.price === 0 ? '#52c41a' : '#d46b08' }}>
                    {plan.price === 0 ? '免费' : '¥' + plan.price}
                  </span>
                  {plan.price > 0 && <span style={{ fontSize: 12, color: '#999' }}>/年</span>}
                </div>
                
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 16px 0' }}>
                  {plan.features.map((f, i) => (
                    <li key={i} style={{
                      fontSize: 12, color: '#666', lineHeight: 2,
                      display: 'flex', alignItems: 'center', gap: 6
                    }}>
                      <span style={{ color: plan.limit ? '#d9d9d9' : '#52c41a' }}>
                        {plan.limit ? '○' : '✅'}
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
                
                {isCurrent ? (
                  <div style={{
                    width: '100%', padding: '8px 0', borderRadius: 8,
                    fontSize: 13, fontWeight: 600, textAlign: 'center',
                    background: '#f0f0f0', color: '#999'
                  }}>当前版本</div>
                ) : canUpgrade ? (
                  <button onClick={() => handleUpgrade(plan.id)} disabled={loading} style={{
                    width: '100%', padding: '8px 0', border: 'none', borderRadius: 8,
                    fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer',
                    background: loading ? '#d9d9d9' : 'linear-gradient(135deg, #fa8c16, #d46b08)'
                  }}>
                    {loading ? '处理中...' : '立即升级 ¥' + plan.price}
                  </button>
                ) : (
                  <div style={{
                    width: '100%', padding: '8px 0', borderRadius: 8,
                    fontSize: 13, fontWeight: 600, textAlign: 'center',
                    background: '#f0f0f0', color: '#999'
                  }}>已拥有</div>
                )}
              </div>
            )
          })}
        </div>
        
        <div style={{ fontSize: 11, color: '#bbb', textAlign: 'center' }}>
          <span style={{ cursor: 'pointer' }} onClick={handleClose}>取消</span>
          <span style={{ margin: '0 8px' }}>|</span>
          <a href="tel:18906588636" style={{ color: '#1890ff', textDecoration: 'none' }}>联系客服</a>
        </div>
      </div>
    </div>
  )
}

const modalOverlay = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', zIndex: 9999,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: 20
}
const modalBox = {
  background: '#fff', borderRadius: 16, padding: 32, maxWidth: 420, width: '100%',
  boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  maxHeight: '90vh', overflowY: 'auto'
}
// ============================================================
// AI顾问气泡组件
// ============================================================
function AiAdvisorBubble({ show, onToggle }) {
  const API = 'https://api.boxiaotu.cn/cms/api'
  const [messages, setMessages] = useState([
    { role: 'ai', text: '你好！我是博小兔企业大脑 AI 顾问 🤖\n\n可以问我：\n• 📊 经营数据（用户/客户/订单）\n• 💼 企业大脑怎么合作\n• 🎓 实战营 / 私董会 / SKILL 授权\n• 🏫 教育产品线（七彩故事工坊等）\n\n直接输入问题或点下面的快捷问题开始！' }
  ])
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const chatRef = useRef(null)

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight
    }
  }, [messages])

  const sendMessage = async () => {
    const text = input.trim()
    if (!text || loading) return
    setInput('')
    setMessages(prev => [...prev, { role: 'user', text }])
    setLoading(true)
    try {
      const token = localStorage.getItem('cms_token') ||
        (() => { try { return JSON.parse(localStorage.getItem('cms_user')).token } catch {} return '' })()
      const res = await fetch(API + '/ai-advisor/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({
          message: text,
          history: []
        })
      })
      const data = await res.json()
      if (data.success && data.data) {
        setMessages(prev => [...prev, { role: 'ai', text: data.data.reply }])
      } else {
        setMessages(prev => [...prev, { role: 'ai', text: '抱歉，暂时无法回答，请稍后再试 😅' }])
      }
    } catch (e) {
      setMessages(prev => [...prev, { role: 'ai', text: '网络错误，请稍后再试 😅' }])
    }
    setLoading(false)
  }

  return (
    <>
      {/* 气泡按钮 */}
      <div onClick={onToggle} style={{
        position: 'fixed', bottom: 32, right: 32, zIndex: 9998,
        width: 56, height: 56, borderRadius: 28,
        background: 'linear-gradient(135deg, #667eea, #764ba2)',
        color: '#fff', display: 'flex', alignItems: 'center',
        justifyContent: 'center', cursor: 'pointer',
        boxShadow: '0 4px 16px rgba(102,126,234,0.4)',
        fontSize: 22, userSelect: 'none'
      }}>
        {show ? '✕' : '💡'}
      </div>

      {/* 中文标签 */}
      {!show && (
        <div style={{
          position: 'fixed', bottom: 90, right: 32, zIndex: 9997,
          fontSize: 11, color: '#667eea', fontWeight: 500,
          textAlign: 'center', pointerEvents: 'none',
          textShadow: '0 1px 2px rgba(255,255,255,0.8)'
        }}>
          AI顾问
        </div>
      )}

      {/* 聊天面板 */}
      {show && (
        <div style={{
          position: 'fixed', bottom: 100, right: 32, zIndex: 9998,
          width: 360, height: 480,
          background: '#fff', borderRadius: 16,
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          display: 'flex', flexDirection: 'column',
          overflow: 'hidden'
        }}>
          {/* 头部 */}
          <div style={{
            padding: '14px 16px',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            color: '#fff', fontWeight: 600, fontSize: 14
          }}>
            🤖 博小兔企业大脑 AI 顾问
          </div>

          {/* 消息列表 */}
          <div ref={chatRef} style={{
            flex: 1, padding: 12, overflowY: 'auto',
            background: '#f8f9fa'
          }}>
            {messages.map((msg, i) => (
              <div key={i} style={{
                display: 'flex',
                justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start',
                marginBottom: 10
              }}>
                <div style={{
                  maxWidth: '85%',
                  padding: '8px 12px',
                  borderRadius: msg.role === 'user' ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
                  background: msg.role === 'user' ? '#667eea' : '#fff',
                  color: msg.role === 'user' ? '#fff' : '#333',
                  fontSize: 13,
                  lineHeight: 1.6,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                }}>
                  {msg.text}
                </div>
              </div>
            ))}
            {loading && (
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 10 }}>
                <div style={{
                  padding: '8px 12px', borderRadius: '12px 12px 12px 2px',
                  background: '#fff', fontSize: 13, color: '#999'
                }}>思考中...</div>
              </div>
            )}
          </div>

          {/* 快捷问题 */}
          <div style={{ padding: '6px 10px', display: 'flex', flexWrap: 'wrap', gap: 6, borderTop: '1px solid #f0f0f0', background: '#fafafa' }}>
            {[
              { label: '🎨 AI动画怎么玩？', text: 'AI动画怎么玩' },
              { label: '💰 产品价格', text: '全部产品价格' },
              { label: '🔢 扣费规则', text: '扣费怎么算' },
              { label: '👶 适合几岁', text: '适合几岁的孩子' },
              { label: '📖 七彩谷故事', text: '七彩谷的故事讲什么' },
              { label: '🤝 成为推广员', text: '如何成为推广员' },
              { label: '🎪 活动研学', text: '有什么活动和研学' },
              { label: '📚 有什么课程', text: '有什么课程' },
            ].map((q, i) => (
              <button key={i} onClick={() => {
                setInput(q.text)
                setTimeout(() => sendMessage(), 50)
              }} style={{
                padding: '4px 10px', border: '1px solid #e0e0e0', borderRadius: 12,
                background: '#fff', fontSize: 11, color: '#555', cursor: 'pointer',
                whiteSpace: 'nowrap'
              }}>{q.label}</button>
            ))}
          </div>

          {/* 输入区 */}
          <div style={{
            padding: 10, borderTop: '1px solid #f0f0f0',
            display: 'flex', gap: 8
          }}>
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && sendMessage()}
              placeholder="输入你的问题..."
              style={{
                flex: 1, padding: '8px 12px', border: '1px solid #e8e8e8',
                borderRadius: 8, fontSize: 13, outline: 'none'
              }}
            />
            <button onClick={sendMessage} style={{
              padding: '8px 16px', border: 'none', borderRadius: 8,
              background: !input.trim() ? '#d9d9d9' : loading ? '#b0b0b0' : 'linear-gradient(135deg, #667eea, #764ba2)',
              color: '#fff', fontSize: 13,
              cursor: !input.trim() || loading ? 'not-allowed' : 'pointer'
            }}>{loading ? '...' : '发送'}</button>
          </div>
        </div>
      )}
    </>
  )
}

function MenuItem({ label, active, onClick, locked }) {
  return (
    <div
      onClick={locked ? onClick : onClick}
      style={{
        padding: '8px 12px',
        marginBottom: 4,
        borderRadius: 6,
        cursor: locked ? 'not-allowed' : 'pointer',
        fontSize: 13,
        color: locked ? '#666' : (active ? '#fff' : '#ccc'),
        background: active ? '#1890ff' : 'transparent',
        opacity: locked ? 0.5 : 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
      onMouseEnter={e => !active && !locked && (e.target.style.background = '#ffffff10')}
      onMouseLeave={e => !active && !locked && (e.target.style.background = 'transparent')}
    >
      <span>{label}</span>
      {locked && <span style={{ fontSize: 11 }}>🔒</span>}
    </div>
  )
}
